import React, { Component } from 'react';

class Input extends Component {
    renderHelperText = () => {
        if (this.props.helperText !== "") {
            return (
                <div className="form-text">
                    {this.props.helperText}
                </div>
            );
        }
        return null;
    }
    renderErrorText = () => {
        if (this.props.errorText !== "") {
            return (
                <div className="text-danger">{this.props.errorText}</div>
            )
        }
        return null;
    }

    render() {
        const { label, name, type, required, onChange, value } = this.props;
        return (
            <div className="form-group">
                <label className="contact_label" htmlFor={name}>{label} {required ? <span className="badge bg-danger">必須</span> : ""}</label>
                <input className="form-control" id={name} onChange={onChange} type={type} name={name} value={value} />
                {this.renderHelperText()}
                {this.renderErrorText()}

            </div>
        );
    }
}

export default Input;